import React from 'react';
import FlowContext from '../context/FlowContext';

export default function useFlowContext() {
    return React.useContext(FlowContext);
}
